import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
        <div className="page-header">
            <h1>Terms and Conditions</h1>
            <p>Welcome to Luxury With Flair. By accessing our website and using our services, you agree to comply with and be bound by the following terms and conditions.</p>
        </div>

        <h2>1. Introduction</h2>
        <p>These Terms and Conditions govern your use of our website and services. By booking a trip or using our services, you agree to abide by these terms.</p>

        <h2>2. Booking and Payments</h2>
        <ul>
            <li>All bookings require a deposit to confirm reservations.</li>
            <li>Full payment must be made before the departure date.</li>
            <li>Prices are subject to change based on availability and currency fluctuations.</li>
        </ul>

        <h2>3. Cancellations and Refunds</h2>
        <ul>
            <li>Cancellations made 30 days before the departure are eligible for a partial refund.</li>
            <li>Last-minute cancellations (within 7 days of departure) may not be eligible for a refund.</li>
            <li>Refunds are subject to service provider policies.</li>
        </ul>

        <h2>4. Travel Insurance</h2>
        <p>We highly recommend purchasing travel insurance to cover unforeseen circumstances such as cancellations, medical emergencies, or lost luggage.</p>

        <h2>5. Liability</h2>
        <p>Luxury With Flair is not responsible for delays, cancellations, accidents, or any losses incurred due to third-party service providers.</p>

        <h2>6. Code of Conduct</h2>
        <p>All travelers are expected to behave respectfully and follow local laws and regulations.</p>

        <h2>7. Changes to Terms</h2>
        <p>We reserve the right to update these terms at any time. Continued use of our services constitutes acceptance of the revised terms.</p>

        <h2>8. Contact Information</h2>
        <p>If you have any questions about our terms, please contact us at support@luxurywithflair.com.</p>
    </div>
  );
};

export default TermsAndConditions;
